export const PROJECT_STATUS = {
    active: 'Y',
    inactive: 'N'
};
